import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'

const initialState = {
  badge: {
    name: 'Test Badge'
  }
}

function rootReducer(state, action) {
  console.log(action.type);
  switch (action.type) {
    case 'GET_BADGE_SUCCESS':
      return { badge: {... action.json}};
  }
  return state;
}

export default function configureStore() {
  const store = createStore(
    rootReducer,
    initialState,
    applyMiddleware(thunk)
  );
  return store;
}
